import { moeda, percentual } from '../lib/formato.js';

export interface Barra {
  nome: string;
  valor: number;
  /** Família da reforma (IBS/CBS): pinta em ochre para separar do sistema atual. */
  rtc?: boolean;
}

/**
 * Série única por família — não há legenda porque a cor já é o próprio
 * agrupamento, e o valor vai escrito ao lado da barra em vez de num eixo.
 */
export function Barras({ series }: { series: Barra[] }) {
  const visiveis = series.filter((s) => s.valor > 0.005).sort((a, b) => b.valor - a.valor);
  if (visiveis.length === 0) return null;

  const maximo = visiveis[0]?.valor ?? 1;
  const soma = visiveis.reduce((acc, s) => acc + s.valor, 0);

  return (
    <div className="chart">
      <div className="bars">
        {visiveis.map((s) => (
          <div
            key={s.nome}
            className={`bar-row${s.rtc ? ' is-rtc' : ''}`}
            title={`${s.nome}: ${moeda(s.valor)} — ${percentual((s.valor / soma) * 100)} do total destacado`}
          >
            <div className="name">
              <i />
              {s.nome}
            </div>
            <div className="track">
              <div className="fill" style={{ width: `${((s.valor / maximo) * 100).toFixed(2)}%` }} />
            </div>
            <div className="amt">{moeda(s.valor)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
